module.exports = __webpack_public_path__ + "static/img/gzh.89e4bc4b.jpg";